export function getFlagIconName(nation: string): string | null {
    switch (nation) {
        case 'RUS':
            return 'circle-flags:ru';
        case 'KAZ':
            return 'circle-flags:kz';
        case 'BLR':
            return 'circle-flags:by';
        case 'RSO':
            return 'circle-flags:south-ossetia';
        case 'GEO':
            return 'circle-flags:ge';
        case 'UAE':
            return 'circle-flags:ae';
        case 'FRA':
            return 'circle-flags:fr';
        case 'LAT':
            return 'circle-flags:lv';
        case 'ALG':
            return 'circle-flags:dz';
        case 'DZA':
            return 'circle-flags:dz';
        case 'SRB':
            return 'circle-flags:rs';
        case 'AUT':
            return 'circle-flags:at';
        case 'EST':
            return 'circle-flags:ee';
        case 'CYP':
            return 'circle-flags:cy';
        case 'FIN':
            return 'circle-flags:fi';
        case 'LTU':
            return 'circle-flags:lt';
        case 'MDA':
            return 'circle-flags:md';
        case 'NOR':
            return 'circle-flags:no';
        case 'PHI':
            return 'circle-flags:ph';
        case 'PHL':
            return 'circle-flags:ph';
        case 'POL':
            return 'circle-flags:pl';
        case 'PRK':
            return 'circle-flags:kp';
        case 'UKR':
            return 'circle-flags:ua';
        default:
            return null;
    }
}